import { createStore } from 'vuex'
import { mainLangValues } from '../plugins/language.js'
import { commonValues } from '../plugins/common-lang.js'
import { popupValues } from '../plugins/popup-lang.js'
import { errorCodes } from '../plugins/error-code.js'

export default createStore({
    state: {
        lang: 'en',
        evtApiServer: process.env.VUE_APP_API_SERVER,
        evtGameServers: undefined,
        evtBase: {},
        isLiveServer: process.env.VUE_APP_IS_LIVE,
        langValues: Object.assign(mainLangValues, popupValues, commonValues),
        errorCodes,
        isLoading: false,
        isForm: false,
        preregSubmitTick: {
            time: 0,
            event: null
        }
    },
    getters: {
        getLangValue: (state) => (transCode) => {
            let lang = state.langValues[transCode]
            if (lang) {
                return lang[state.lang] ?? `Not found text Key/Lang=>(${transCode}/${state.lang})`
            }
            else {
                return `Not found text Key=>(${transCode})`
            }
        },
        getEventConfig(state) {
            return state.evtGameServers
        }

    },
    mutations: {
        setEventConfig(state, evtConfig) {
            state.evtGameServers = evtConfig
        },
    },
    actions: {
        fetchEventConfig({ state, commit }) {

            let config = []
            let evtId = process.env.VUE_APP_CONF_EVENT_ID.split(';')
            let svrName = process.env.VUE_APP_CONF_SERVER_NAME.split(';')
            let evtKey = process.env.VUE_APP_CONF_EVENT_KEY.split(';')
            let isShow = process.env.VUE_APP_CONF_IS_VISIBLE.split(';')

            evtId.forEach((evt, idx, arr) => {

                if (evt) {
                    config.push({
                        eventId: evtId[idx].trim(),
                        serverName: svrName[idx].trim(),
                        eventKey: evtKey[idx].trim(),
                        isVisible: isShow[idx].trim()
                    })
                }

            })

            commit("setEventConfig", config);
        
        }
    },
    modules: {

    }
})
